export const layout = {
    default: ['Q W E R T Y U I O P Å','A S D F G H J K L Ö Ä','Z X C V B N M ⟸ {space} ↵ ⌨️']
}
export const sudokuLayout = {
    default: ['1 2 3 Clear', '4 5 6 Empty', '7 8 9 ']
}
